import React, { createContext, useState, useEffect } from "react";

export const context = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    // Obtener el token almacenado en localStorage al inicio de la aplicación
    const storedToken = localStorage.getItem("token");
    return storedToken || null;
  });

  const handleLogin = (newToken) => {
    setToken(newToken);
    localStorage.setItem("token", newToken); // Almacenar el token en localStorage
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem("token"); // Eliminar el token del localStorage
  };

  // Estado y funciones para el SideMenu
  const [showSideMenu, setShowSideMenu] = useState(false);

  const handleShowSideMenu = () => setShowSideMenu(true);
  const handleCloseSideMenu = () => setShowSideMenu(false);

  useEffect(() => {
    // No hagas nada en este efecto, solo se ejecuta una vez al inicio
  }, []);

  return (
    <context.Provider
      value={{
        token,
        handleLogin,
        handleLogout,
        showSideMenu,
        handleShowSideMenu,
        handleCloseSideMenu,
      }}
    >
      {children}
    </context.Provider>
  );
}
